import {NAVIGATE_TO} from '../constants'

export function navigateTo(path) {
  return {type: NAVIGATE_TO, path}
}
